import { Link } from 'react-router-dom';
import { Poster } from './Poster';
import type { Drama } from '../lib/types';

interface Props {
  drama: Drama;
  /** Tampilkan label platform (dipakai di feed "Semua Provider"). */
  showPlatform?: boolean;
}

/**
 * Kartu drama dgn poster 2:3. Placeholder gradient bila `cover` null /
 * gagal load, supaya UI tidak "rusak".
 */
export function DramaCard({ drama, showPlatform = false }: Props) {
  return (
    <Link
      to={`/drama/${drama.platform}/${drama.id}`}
      className="group block"
      aria-label={drama.title}
    >
      <div className="relative aspect-poster overflow-hidden rounded-lg bg-neutral-800">
        <Poster
          src={drama.cover}
          title={drama.title}
          className="transition-transform group-hover:scale-105"
        />
        {drama.totalEpisodes !== null && drama.totalEpisodes > 0 && (
          <span className="absolute right-1.5 top-1.5 rounded bg-black/60 px-1.5 py-0.5 text-[10px] font-medium text-white backdrop-blur">
            {drama.totalEpisodes} ep
          </span>
        )}
        {drama.views && (
          <span className="absolute bottom-1.5 left-1.5 flex items-center gap-1 rounded bg-black/60 px-1.5 py-0.5 text-[10px] text-white backdrop-blur">
            <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 5.1v13.8c0 .8.9 1.3 1.6.9l10.7-6.9a1 1 0 0 0 0-1.7L9.6 4.2A1 1 0 0 0 8 5.1z" />
            </svg>
            {drama.views}
          </span>
        )}
        {showPlatform && (
          <span className="absolute bottom-1.5 right-1.5 rounded bg-black/70 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-gold-light backdrop-blur">
            {drama.platform}
          </span>
        )}
      </div>
      <h3 className="mt-2 line-clamp-2 text-sm font-medium leading-tight">
        {drama.title}
      </h3>
    </Link>
  );
}
